import { render, staticRenderFns } from "./lotteryHall.vue?vue&type=template&id=0931fbf8&scoped=true"
import script from "./lotteryHall.vue?vue&type=script&lang=js"
export * from "./lotteryHall.vue?vue&type=script&lang=js"
import style0 from "./lotteryHall.vue?vue&type=style&index=0&id=0931fbf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0931fbf8",
  null
  
)

export default component.exports